import { Reveal, SectionHeading } from "@/components/Reveal";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { useSite } from "@/context/SiteContext";
import { HERO_IMAGES } from "@/lib/constants";

export default function MaterialsSection() {
  const { openQuote } = useSite();
  return (
    <section className="bg-ink-950 py-14 sm:py-28" data-testid="materials-section">
      <div className="container-brox grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <div className="relative">
            <div className="absolute -left-3 -top-3 h-full w-full border border-copper/40" aria-hidden="true" />
            <img
              src={HERO_IMAGES.materials}
              alt="Materiale de construcții pregătite pentru montaj"
              loading="lazy"
              className="relative h-60 w-full object-cover sm:h-96"
              data-testid="materials-image"
            />
          </div>
        </Reveal>
        <div>
          <SectionHeading eyebrow="MATERIALE" title="Ai nevoie și de materiale?" />
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-muted-foreground sm:text-lg" data-testid="materials-copy">
              Prin rețeaua noastră de furnizori putem integra în proiect atât manopera, cât și materialele
              necesare. Coordonăm aprovizionarea în ritmul lucrării, ca să nu aștepți niciodată materialele.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <button
              onClick={() => openQuote({ source: "materials", materials_needed: true })}
              className="btn-primary copper-sheen mt-7 w-full sm:w-auto"
              data-testid="materials-cta"
            >
              <WhatsAppIcon className="h-5 w-5" />
              VREAU MANOPERĂ + MATERIALE
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
